module.exports = __webpack_public_path__ + "img/use-password-manager.edaef709.svg";